export default __webpack_public_path__ + "static/media/event_item1.83ad3e0c.png";